import BaseService from "src/packages/BaseService";
import axios from "../packages/MyAxios";

export default class ScoreService extends BaseService {
	static get className () {
		return "score";
	}


	static fetch (game,params = {}) {
		return axios.get(`game/${game}/scores`, { params }).then(
			(response) => {
				return response.data;
			}
		);
	}

	static create (score = {}) {
		return axios.post(`game/${score.game_id}/scores`, { score }).then(
			(response) => {
				return response.data;
			}
		);
	}

	static remove (id, dataUrl = {}) {
		return axios.delete(`game/${id}/scores`, dataUrl).then(
			response => {
				return response.data;
			}
		);
	}
}
